import { ElementAudioSource } from './ElementAudioSource';
import { BufferAudioData } from './BufferAudioData';
import { BufferAudioSource } from './BufferAudioSource';
import { AudioDevice } from './AudioDevice';
import { AudioData } from './AudioData';
import { AudioSource } from './AudioSource';
import { AudioDataSource } from './AudioDataSource';
import { IMediaContainer } from './IMediaContainer';
import { ElementAudioData } from './ElementAudioData';

export class AudioDeviceWebAudioApi extends AudioDevice {
  private readonly _context: AudioContext;

  constructor(context: AudioContext) {
    super();
    this._context = context;
  }

  get context(): AudioContext {
    return this._context;
  }

  async openStreamInContainer(
    sources: AudioDataSource[],
    _container: IMediaContainer
  ): Promise<AudioData | null> {
    return BufferAudioData.Load(this._context, sources, true);
  }

  async decodeBuffer(sources: AudioDataSource[]): Promise<AudioData | null> {
    return BufferAudioData.Load(this._context, sources);
  }

  async openStream(sources: AudioDataSource[]): Promise<AudioData | null> {
    return BufferAudioData.Load(this._context, sources, true);
  }

  createSourceImpl(data: BufferAudioData | ElementAudioData): AudioSource {
    if (data instanceof BufferAudioData) {
      return new BufferAudioSource(this._context, data);
    }
    return new ElementAudioSource(data);
  }

  destroySourceImpl(source: AudioSource): void {
    if (source) {
      source.stop();
    }
  }
}
